const enviroment = {
  apiUrl: 'https://api.credex.com.ni/',
  remittancesAPI: 'https://zucash-api-yh7mh2kwba-ue.a.run.app/',
  sentryDSN:
    'https://0e32411c87e6e581a3475cd0195a0b3c@o4507986424496128.ingest.us.sentry.io/4507987014451200',
}

export default enviroment
